import React, { useEffect, useState } from 'react';
import { Card, CardContent, Avatar, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions, Box, Alert } from '@mui/material';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import * as constants from "./constants.js"
import avatarImage from './img/stadt.png';

const RegionCard = ({ regionId }) => {
  const [name, setName] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteError, setDeleteError] = useState(null);
  const [ownRegion, setOwnRegion] = useState('');
  const [accepted, setAccepted] = useState('');
  const navigate = useNavigate();

  const cardStyle = {
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center', // Center items vertically
    justifyContent: 'space-between', // Distribute items evenly along the main axis
    padding: '15px', // Add padding for better spacing
  };

  const buttonsContainerStyle = {
    display: 'flex',
    alignItems: 'center', // Center items vertically
    gap: '10px', // Add spacing between buttons
  };

  useEffect(() => {
    (async () => {
        try {
            const resp = await axios.create({
                withCredentials: true,
            }).get("//" + constants.BASE_URL + "/get_region_name/" + regionId.toString());
            setName(resp.data.name);
            setAccepted(resp.data.accepted);
            setOwnRegion(resp.data.own_region)
        } catch (error) {
            navigate('/login');
            console.error('Error fetching data:', error);
        }
    })();
  }, [regionId]);

  const handleCloseDialog = () => {
    setDeleteError(null);
    setOpenDialog(false);
  };

  const confirmDelete = async () => {
    try {
        const resp = await axios.create({
            withCredentials: true,
        }).post("//" + constants.BASE_URL + "/deleteRegion", {
          id: regionId,
        });
      setOpenDialog(false);
      window.location.reload(false);
    } catch (error) {
      setDeleteError(error.response?.data?.error || "Das Löschen ist fehlgeschlagen.");
    }
  };

  const deleteButtonStyle = {
    position: 'absolute',
    bottom: '50px', // Adjust vertical position as needed
    right: '-10px',
    transform: 'translateX(-50%)', // Center horizontally
  };

  const handleDelete = async () => {
    setOpenDialog(true); // Open the dialog for confirmation
  };

  const handleOverview = () => {
    navigate("/region-overview/" + regionId.toString())
  };

  const handleAccept = async () => {
    try {
        const resp = await axios.create({
            withCredentials: true,
        }).post("//" + constants.BASE_URL + "/acceptShareRegion", {
          region_id: regionId,
        });
      window.location.reload(false);
    } catch (error) {
      console.error('Error accepting region:', error);
    }
  };

  return (
    <Card style={cardStyle}>
        <Avatar alt={name} src={avatarImage} sx={{ width: 100, height: 100, margin: '2px'  }} />
        <CardContent style={{ flex: 1 }}>
        <Typography variant="h6" component="div">
          {name}
        </Typography>
      </CardContent>
      <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
      <div style={buttonsContainerStyle}>
      {!accepted && (
        <Button variant="contained" onClick={handleAccept}>
          Freigabe Akzeptieren
        </Button>
      )}
      <Button variant="contained" onClick={handleOverview}>
        Übersicht
      </Button>
      {ownRegion && (
        <Button variant="contained" color="error" onClick={handleDelete}>
          Löschen
        </Button>
      )}
      </div>
      </Box>
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Löschen bestätigen</DialogTitle>
        <DialogContent>
          Sind Sie sicher, dass Sie diese Region löschen wollen?
          {deleteError && <Alert severity="error" sx={{ mt: 1 }}>{deleteError}</Alert>}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Abbrechen</Button>
          {!deleteError && (
            <Button onClick={confirmDelete} variant="contained" color="error">
              Löschen
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default RegionCard;
